import { createSelector } from 'redux-orm';

import orm from '../orm';

export const selectContentCardDefaultsForPointSystem = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  ({ ContentCardDefault }, pointSystemId) => {
    if (!pointSystemId) {
      return [];
    }

    const id = String(pointSystemId);

    return ContentCardDefault.all()
      .toRefArray()
      .filter((item) => String(item.pointSistemId) === id)
      .sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0));
  },
);

export const selectContentCardDefaultsByPointSystemAndType = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  (_, __, type) => type,
  ({ ContentCardDefault }, pointSystemId, type) => {
    if (!pointSystemId) {
      return [];
    }

    const id = String(pointSystemId);
    let items = ContentCardDefault.all()
      .toRefArray()
      .filter((item) => String(item.pointSistemId) === id);

    if (type) {
      items = items.filter((item) => item.type === type);
    }

    return items.sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0));
  },
);

export default {
  selectContentCardDefaultsForPointSystem,
  selectContentCardDefaultsByPointSystemAndType,
};

